import { Box } from '@mui/system';
import React from 'react';

export const TextTruncated = ({
  text,
  maxWidth = 128,
}: {
  text: string;
  maxWidth?: number;
}) => (
  <Box
    sx={{
      maxWidth,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline-block',
    }}
    title={text}
  >
    {text}
  </Box>
);
